import React from 'react';
import { ButtonLink } from '@hemnet/component-library/componentsUsingGlobalStyling';
import PropTypes from 'prop-types';

function SystemMessageLink({ link, text }) {
  return (
    <div className="system-message__action">
      <ButtonLink href={link} styleType="secondary">
        {text}
      </ButtonLink>
    </div>
  );
}

SystemMessageLink.propTypes = {
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default SystemMessageLink;
